<template>
  <template v-if="contentStore.select_screen != null">

        <v-menu 
          v-model="dialog_com"
          location="start"
          :close-on-content-click="false"
          @update:modelValue="menu_handler"
          >
          <template v-slot:activator="{ props }">
            <div v-bind="props" style="cursor:pointer" class="d-flex justify-center">
            <div style="width:25px;height:25px;border:1px gray solid"
                 :style="{ background : contentStore.select_screen.backgroundColor }"
                 />
            </div>
          </template>

          <v-card class="ma-0 pa-1">
            <v-row dense align="center" class="pa-0 ma-0">
              <v-col cols="9" class="ml-5 mt-2">
                <label style="color:black">{{title}}</label>
              </v-col>
              <v-col cols="2" class="mt-2">
                <v-btn size="small" icon class="dialog_close_btn mr-1" @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>

            <v-row dense justify="center" class="pa-0 ma-0">
              <v-col cols="11">
                <div style="background:gray;height:1px;" />
              </v-col>
            </v-row>
            
            <v-card-text>
              <v-container>

                <!-- 그라데이션 프리셋 목록 -->
                <v-row dense class="mb-3">
                  <v-col cols="12">
                    <label style="font-size:12px;color:#666">자주 사용하는 그라데이션</label>
                    <div style="max-height: 120px; width:270px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px; padding: 4px; margin-top: 4px;">
                      <v-row dense>
                        <v-col v-for="preset in gradientPresets" :key="preset.id" cols="6" class="pa-1">
                          <div 
                            @click="selectPreset(preset.gradient)"
                            style="height: 30px; border-radius: 4px; cursor: pointer; border: 1px solid transparent; position: relative;"
                            :style="{ background: preset.gradient, border: contentStore.select_screen.backgroundColor === preset.gradient ? '2px solid #1976d2' : '2px solid #e0e0e0' }"
                            class="preset-item"
                          >
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>

                <!-- 커스텀 그라데이션 설정 -->
                <v-row dense>
                  <v-col cols="12">
                    <label style="font-size:12px;color:#666">커스텀 그라데이션</label>
                    <Vue3ColorPicker style="width: 270px;" class="elevation-0"
                      v-model="contentStore.select_screen.backgroundColor" 
                      mode="gradient" 
                      :show-eye-drop="true" :show-input-menu="true"
                      @update:modelValue="updateRender" 
                      />
                  </v-col>
                </v-row>

              </v-container>
            </v-card-text> 

            <v-row dense justify="center" class="pa-0 ma-0">
              <v-col cols="11">
                <div style="background:gray;height:1px;" />
              </v-col>
            </v-row>

            <v-card-actions>
              <v-row justify="center">
              <v-btn variant="text" size="small" @click="close_com">취소</v-btn>
              <v-btn variant="text" size="small" class="ml-5" @click="save_com">선택</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>

        </v-menu>


  </template>
  
</template>

<script>
import { Vue3ColorPicker } from '@cyhnkckali/vue3-color-picker';
import '@cyhnkckali/vue3-color-picker/dist/style.css'
import { useContentStore } from "@/stores/content";
import { allGradientPresets } from '@/assets/js/gradientPresets';


    export default {

      components:{
        Vue3ColorPicker
      },

        props:{
          
          title:{
            type:String,
            default(){
              return "";
            }
          },
          
          property:{
            type:String,
            default(){
              return "";
            }
          },
          
        },

        setup(){
          const contentStore = useContentStore();
          return {contentStore};
        },
        
        created(){
          //console.log("dialog gr color created");
        },

        mounted(){
          //console.log("dialog gr color mounted");
        },

        data: ()=> ({
            dialog_com : false,
            disabled:false,
            text_backup:"",
            gradientPresets: allGradientPresets,
        }),

        methods: {
          
            //다이얼로그 닫기
            close_com () {
              this.contentStore.select_screen.backgroundColor = this.text_backup;
              this.updateRender();
              this.dialog_com = false
            },

            //추가 저장
            save_com () {
              this.updateRender();
              this.dialog_com = false
            },      

            menu_handler(){
              //최초 또는 메뉴 외곽 클릭시 
              //텍스트값 백업
              this.text_backup = this.contentStore.select_screen.backgroundColor;
            },

            //편집창 컴포넌트 렌더링
            updateRender(){
              this.$emitter.emit("drawscreen");
            },

            //프리셋 선택
            selectPreset(gradient){
              // 즉시 모델 업데이트 및 렌더링
              console.log(`gradient color  : ${gradient}`);
              this.contentStore.select_screen.backgroundColor = gradient;
              this.updateRender();
            },

        }

    }
</script>

<style scoped>
.preset-item:hover {
  transform: scale(1.05);
  transition: transform 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
</style>